import Card from '~/components/Card';
import LinkButton from '~/components/LinkButton';
import Page from '~/components/Page';
import { useLoaderData } from './shopNow';
import ShopNowReturnCredit from './ShopNowReturnCredit';
import ShopNowSteps, { ShopNowStep } from './ShopNowSteps';

const perkItems = [
  {
    icon: 'DollarSign' as const,
    title: 'Make more for your return',
    description:
      'Because we think we you can find something new to love, we have added a little extra to your return credit. ',
  },
  {
    icon: 'MagnifyingGlass' as const,
    title: 'Explore our latest arrivals',
    description:
      'Browse the latest arrivals chosen to complement what you already love.',
  },
  {
    icon: 'ArrowRightArrowLeft' as const,
    title: 'Instant credit applied',
    description:
      'Your return credit is automatically applied at checkout—no codes or guesswork.',
  },
  {
    icon: 'Truck' as const,
    title: 'Faster returns',
    description:
      'Avoid out of stock delays. Enjoy speedy shipping on us when you complete your exchange with Shop Now.',
  },
] satisfies ShopNowStep[];

// TODO: SHOP NOW decide what button layout, we want to implement before go live
// TODO: determine if merchant configured text makes sense here
export default function ShopNowPage() {
  const { headline, incentive, credit } = useLoaderData();

  return (
    <Page headline="Shop Now Offer" hideHeader className="gap-8">
      <Card className="gap-8 p-6 md:p-10" headline={headline} hideHeader>
        <ShopNowReturnCredit credit={credit} incentive={incentive} />
        <section className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Why shop now?
            </h3>
            <p className="mt-1 text-sm text-gray-600">
              Put your credit to work instantly to get your new items faster.
            </p>
          </div>
          <ShopNowSteps steps={perkItems} />
        </section>
        <div className="flex flex-col gap-4">
          <LinkButton className="md:w-1/2" variant="filled" to="start">
            Shop Now
          </LinkButton>
          <LinkButton variant="text" to="../address">
            No thanks, continue with return
          </LinkButton>
        </div>
      </Card>
    </Page>
  );
}
